var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useFormatters from "../../../hooks/useFormatters";
import { Icon } from "@brushfire/ui";
var CalendarDate = function (_a) {
    var events = _a.events, view = _a.view, lowestPrice = _a.lowestPrice;
    var intl = useFormatters();
    if (view !== "month") {
        return null;
    }
    return (_jsxs(_Fragment, { children: [events.some(function (evt) { return evt.hasStickyInfo; }) && _jsx(Icon, { icon: "star", type: "solid", classes: "primary sticky-icon" }), events.some(function (evt) { return evt.hasAdvertisedPrice; }) && lowestPrice !== null && (_jsx("div", __assign({ className: "calendar-price-pill" }, { children: lowestPrice === 0 ? "FREE" : intl.formatCurrencyRounded(lowestPrice) }))), events.every(function (evt) { return evt.isSoldOut; }) && _jsx("div", __assign({ className: "calendar-sold-out-banner" }, { children: "Sold Out" }))] }));
};
export default CalendarDate;
